import React from 'react';
import styled, { withTheme } from 'styled-components';

import SearchBarContainer from '../shared/SearchBarContainer';
import SearchIconFillable from '../../../svgs/SearchIconFillable';
import MobileCloseIconSvg from '../../../svgs/MobileCloseIconSvg';
import SearchDropdown from '../shared/SearchDropdown';

const SearchBarMobileDiv = styled.div`
  z-index: 9;
  width: 100%;
`;

const SearchBarRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${p => p.theme.c.bg.primary};
  height: 100%;
  box-sizing: border-box;
  border-style: solid;
  border-width: 1px;
  border-color: ${p => p.theme.c.border.secondary};
  border-radius: 4px;
  margin-left: 2px;
`;

const SearchBarDiv = styled.div`
  position: relative;
  padding: ${p => p.theme.unit(1)};
  background-color: ${p => p.theme.c.bg.primary};
  box-shadow: 0 1px 0 0 ${p => p.theme.c.border['box-shadow']};
`;

const SearchInput = styled.input`
  ${p => p.theme.typographyRebrand.body.md}
  flex-grow: 1;
  text-overflow: ellipsis;
  border: 0;
  padding: 0 0 0 16px;
  ::placeholder {
    color: ${p => p.theme.c.text.secondary};
    ${p => p.theme.typographyRebrand.body.md}
  }
  margin: 0 ${p => p.theme.unit(0.25)};
`;

const IconContainerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${p => p.theme.unit(3)};
  width: ${p => p.theme.unit(3)};
  min-width: ${p => p.theme.unit(3)};
  padding: ${p => p.theme.unit(0.5)} ${p => p.theme.unit(0.5)} ${p => p.theme.unit(0.5)} ${p => p.theme.unit(1)};
  background-color: transparent;
`;

const CloseIconContainerDiv = styled(IconContainerDiv)`
  padding-left: ${p => p.theme.unit(1)};
  margin-left: ${p => p.theme.unit(0.5)};
  margin-right: 0;
`;

const CloseIconButton = styled.button`
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;

class SearchBarMobile extends SearchBarContainer {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state, {
      showIcon: false,
      value: '',
      lang: '',
    });

    this.showCloseIcon = this.showCloseIcon.bind(this);
    this.hideCloseIcon = this.hideCloseIcon.bind(this);
    this.onFocusInput = this.onFocusInput.bind(this);
    this.blurSearchBar = this.blurSearchBar.bind(this);
  }

  componentDidMount() {
    window.addEventListener('touchstart', this.blurSearchBar);
    this.setState({
      lang: document.documentElement.lang,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.blurSearchBar);
  }

  blurSearchBar() {
    document.activeElement.blur();
  }

  showCloseIcon() {
    this.setState({
      showIcon: true,
    });
  }

  hideCloseIcon() {
    this.setState({
      showIcon: false,
      value: '',
    });
    this.clearSearch();
  }

  onFocusInput(e) {
    this.showCloseIcon();
    this.handleChange(e);
  }

  render() {
    const {
      placeholder,
      locale,
      theme,
      searchStoreTitle,
      searchCategoriesTitle,
      searchCtaButtonText,
      searchIconLabel,
      clearSearchLabel,
    } = this.props;

    return (
      <SearchBarMobileDiv>
        <SearchBarDiv>
          <form role="search" onSubmit={e => this.onSearch(e, locale)}>
            <SearchBarRow>
              <SearchInput
                aria-label={searchIconLabel}
                type="text"
                value={this.state.value}
                onChange={this.handleChange}
                placeholder={placeholder}
                onFocus={this.onFocusInput} />
              <IconContainerDiv>
                <SearchIconFillable fill={theme.c.icon.interactive} />
              </IconContainerDiv>
              {this.state.showIcon &&
                <CloseIconContainerDiv>
                  <CloseIconButton onClick={this.hideCloseIcon} aria-label={clearSearchLabel}>
                    <MobileCloseIconSvg title={clearSearchLabel} fill={theme.c.icon.interactive} />
                  </CloseIconButton>
                </CloseIconContainerDiv>
              }
            </SearchBarRow>
          </form>
        </SearchBarDiv>
        <SearchDropdown
          locale={locale}
          shops={this.state.shops}
          categories={this.state.categories}
          mobile
          searchStoreTitle={searchStoreTitle}
          searchCategoriesTitle={searchCategoriesTitle}
          searchCtaButtonText={searchCtaButtonText}
        />
      </SearchBarMobileDiv>
    );
  }
}

export default withTheme(SearchBarMobile);
